/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelMeetingResponseDto
 */
export interface CancelMeetingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CancelMeetingResponseDto
     */
    id?: string;
    /**
     * Meeting Id in third-party calendar
     * @type {string}
     * @memberof CancelMeetingResponseDto
     */
    externalId?: string;
    /**
     * Meeting creator user id
     * @type {string}
     * @memberof CancelMeetingResponseDto
     */
    creator?: string;
    /**
     * Meeting title
     * @type {string}
     * @memberof CancelMeetingResponseDto
     */
    title?: string;
    /**
     * Start time of the meeting
     * @type {string}
     * @memberof CancelMeetingResponseDto
     */
    startTime?: string;
    /**
     * Start time of the meeting
     * @type {string}
     * @memberof CancelMeetingResponseDto
     */
    endTime?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CancelMeetingResponseDto
     */
    participants?: Array<string>;
    /**
     * Was the meeting canceled?
     * @type {boolean}
     * @memberof CancelMeetingResponseDto
     */
    cancelled?: boolean;
}

/**
 * Check if a given object implements the CancelMeetingResponseDto interface.
 */
export function instanceOfCancelMeetingResponseDto(value: object): boolean {
    return true;
}

export function CancelMeetingResponseDtoFromJSON(json: any): CancelMeetingResponseDto {
    return CancelMeetingResponseDtoFromJSONTyped(json, false);
}

export function CancelMeetingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelMeetingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'creator': json['creator'] == null ? undefined : json['creator'],
        'title': json['title'] == null ? undefined : json['title'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'participants': json['participants'] == null ? undefined : json['participants'],
        'cancelled': json['cancelled'] == null ? undefined : json['cancelled'],
    };
}

export function CancelMeetingResponseDtoToJSON(value?: CancelMeetingResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'creator': value['creator'],
        'title': value['title'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'participants': value['participants'],
        'cancelled': value['cancelled'],
    };
}

